// Required "I agree to the Terms of Business" tick box shown on supplier checkouts.
export const TermsTick = ({ checked, onChange, testid = 'terms-tick' }) => (
  <label className="basis-full flex items-start gap-2.5 text-sm text-gray-700 cursor-pointer select-none" data-testid={`${testid}-label`}>
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 w-4 h-4 accent-[#00A79D] cursor-pointer" data-testid={testid} />
    <span>I agree to the{' '}
      <a href="/terms-of-business" target="_blank" rel="noopener noreferrer" className="text-[#00857D] font-semibold underline underline-offset-2" data-testid={`${testid}-link`}>Terms of Business</a>
    </span>
  </label>
);
